import { render, staticRenderFns } from "./DeliveryLabel.vue?vue&type=template&id=4c528623&scoped=true"
import script from "./DeliveryLabel.vue?vue&type=script&lang=js"
export * from "./DeliveryLabel.vue?vue&type=script&lang=js"
import style0 from "./DeliveryLabel.vue?vue&type=style&index=0&id=4c528623&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c528623",
  null
  
)

export default component.exports